<template>
  <section>
    <v-dialog
      v-model="isShow"
      width="400px">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>{{title}}</span>
        </div>
        <div class="dialog-body">
          <template v-if="step == 1">
            <div class="tips">An email will be sent to “{{email}}” with a link to verify with HoldCover. </div>
          </template>

          <template v-if="step == 2">
            <div class="tips">An email has been sent to “{{email}}”</div>
          </template>
        </div>
        <div class="dialog-footer">
          <template v-if="step == 1">
            <v-button
              class="cancel"
              @click="handleCancel">Cancel</v-button>
            <v-button
              class="success"
              @click="handleSend">Send</v-button>
          </template>

          <template v-if="step == 2">
            <v-button
              class="success done"
              @click="handleDone">Done</v-button>
          </template>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import {resendEmail} from '@/api/account'
export default {
  name: 'SendVerfication',
  props:{
    email:{
      type: String,
      default: ''
    }
  },
  data(){
    return{
      isShow: false,
      step: 1,
    }
  },

  computed:{
    title(){
      return this.step == 1? 'Send verification' : 'Verification email sent'
    }
  },

  methods:{
    changeDialog(){
      this.isShow = !this.isShow
    },

    handleCancel(){
      this.step = 1
      this.changeDialog()
    },

    handleSend(){
      this.network().resendEmail()
    },

    handleDone(){
      this.handleCancel()
      this.$emit('sendVerify')
    },

    network() {
      return {
        resendEmail: async ()=>{
          let customer_id = this.$route.query.customer_id||''
          const { data } = await resendEmail({
            user_id: customer_id
          })
          if(data.code == 1000){
            this.step += 1
          }
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
    box-sizing: border-box;
    border-radius: 6px;
  }
  .dialog-container {
    .dialog-header {
      padding: 16px;
      background: #F6F8FA;
      border-bottom: 1px solid #E1E4E8;
      border-radius: 6px 6px 0 0;
      span{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #1B1F23;
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
        /*margin: 10px 0px;*/
      }
    }
    .dialog-body{
      padding: 20px 15px;
      .tips{
        color: #24292E;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      padding-top: 0;
      .el-button{
        background: #FAFBFC;
        border: 1px solid rgba(27, 31, 35, 0.15);
        box-sizing: border-box;
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
        border-radius: 6px;
        font-weight: 600;
        font-family: 'Inter';
      }
      .success{
        background: #2EA44F;
        color: #FFFFFF;
      }
      .cancel{
        color: #24292E;
      }
      .done{
        width: 100%;
      }
    }
  }
</style>
